import { Link } from "react-router-dom";

const services = [
  {
    title: "Sträuße & Geschenkfloristik",
    description: "Individuell gebundene Blumensträuße und liebevolle Geschenkideen für jeden Anlass.",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20hand-tied%20bouquet%20of%20fresh%20garden%20roses%20peonies%20and%20eucalyptus%20in%20soft%20cream%20and%20blush%20pink%20tones%2C%20wrapped%20in%20natural%20kraft%20paper%20with%20ribbon%2C%20warm%20studio%20lighting%2C%20editorial%20floral%20photography%2C%20clean%20neutral%20background%2C%20high%20detail%20and%20texture&width=600&height=400&seq=service-strauess-001&orientation=landscape",
    href: "/strauss-geschenk",
  },
  {
    title: "Hochzeitsfloristik",
    description: "Von der ersten Idee bis zum großen Tag – florale Begleitung für Ihre Hochzeit.",
    image: "https://readdy.ai/api/search-image?query=Elegant%20bridal%20bouquet%20with%20white%20roses%20peonies%20and%20greenery%20held%20by%20bride%20in%20soft%20natural%20light%2C%20romantic%20wedding%20atmosphere%2C%20warm%20cream%20and%20ivory%20tones%2C%20fine%20art%20photography%20style%2C%20shallow%20depth%20of%20field%2C%20ethereal%20and%20timeless%20aesthetic&width=600&height=400&seq=service-hochzeit-001&orientation=landscape",
    href: "/hochzeit",
  },
  {
    title: "Trauerfloristik",
    description: "Respektvolle und würdevolle Gestaltung für Abschiedsgrüße und Gedenken.",
    image: "https://readdy.ai/api/search-image?query=Circular%20funeral%20wreath%20made%20of%20rich%20green%20foliage%20fir%20branches%20eucalyptus%20and%20laurel%20leaves%2C%20adorned%20with%20an%20elegant%20deep%20green%20satin%20ribbon%20bow%20flowing%20down%20at%20the%20bottom%2C%20resting%20on%20a%20soft%20neutral%20cream%20background%2C%20respectful%20and%20dignified%20memorial%20composition%2C%20warm%20natural%20lighting%2C%20editorial%20floral%20photography%2C%20serene%20peaceful%20atmosphere%2C%20high%20detail%20and%20texture&width=600&height=400&seq=service-trauer-001&orientation=landscape&nocache=true",
    href: "/trauer",
  },
  {
    title: "Event- & Firmenfloristik",
    description: "Florale Konzepte für Feiern, Jubiläen und geschäftliche Anlässe.",
    image: "https://readdy.ai/api/search-image?query=Elegant%20table%20centerpiece%20arrangement%20with%20tall%20candles%20and%20flowers%20in%20a%20luxury%20event%20space%2C%20warm%20ambient%20lighting%2C%20sophisticated%20dinner%20setting%2C%20cream%20roses%20and%20greenery%2C%20editorial%20event%20photography%2C%20refined%20and%20elegant%20atmosphere&width=600&height=400&seq=service-event-001&orientation=landscape",
    href: "/event",
  },
  {
    title: "Pflanzen & Dekoration",
    description: "Über 500 m² Floristik, Pflanzen und saisonale Dekorationsideen.",
    image: "https://readdy.ai/api/search-image?query=Bright%20plant%20shop%20interior%20with%20lush%20green%20potted%20plants%20arranged%20on%20wooden%20shelves%20and%20tables%2C%20warm%20natural%20light%20streaming%20through%20windows%2C%20terracotta%20pots%20and%20ceramic%20planters%2C%20editorial%20interior%20photography%2C%20cream%20walls%20and%20organic%20textures%2C%20inviting%20and%20fresh%20atmosphere&width=600&height=400&seq=service-pflanzen-001&orientation=landscape",
    href: "/pflanzen",
  },
  {
    title: "Fleurop & Lieferservice",
    description: "Persönlich gestaltete Blumen zuverlässig versenden – als 5-Sterne-Florist.",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20flower%20delivery%20box%20with%20fresh%20roses%20and%20greenery%20being%20prepared%20by%20florist%20hands%2C%20gift%20wrapping%20with%20natural%20materials%2C%20warm%20studio%20lighting%2C%20cream%20and%20soft%20green%20tones%2C%20editorial%20product%20photography%2C%20thoughtful%20and%20caring%20gesture%20atmosphere&width=600&height=400&seq=service-fleurop-001&orientation=landscape",
    href: "https://www.fleurop.de/partnerfloristen/fleurop-filialen/26789-leer/florale-manufaktur-blumen-stoehr-gmbh-heisfelder-str-105",
    external: true,
  },
];

export default function ServiceCards() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">
            Unsere Leistungen
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            Entdecken Sie die Vielfalt unserer floralen Manufaktur – von individuellen Sträußen bis zur umfassenden Event-Gestaltung.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service) => {
            const cardContent = (
              <>
                <div className="aspect-[3/2] overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
                    {service.description}
                  </p>
                  <span className="inline-flex items-center text-primary-600 text-sm font-medium group-hover:text-primary-700 transition-colors">
                    Mehr erfahren
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center ml-1 group-hover:translate-x-1 transition-transform"></i>
                  </span>
                </div>
              </>
            );

            return service.external ? (
              <a
                key={service.href}
                href={service.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:shadow-lg"
              >
                {cardContent}
              </a>
            ) : (
              <Link
                key={service.href}
                to={service.href}
                className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:shadow-lg"
              >
                {cardContent}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}